import { request } from './index'
import config from '@/config'

const commonServiceRequest = (method, url, params) => {
  console.log(config)
  return request(method, url, params, config.mainApps.commonService, config.mainApps.commonService.baseURL)
}

export { commonServiceRequest }
